import templateService from '../../services/template-service';
import DialogComponent from '../widgets/dialog/DialogComponent';

export default class CreateTemplateDialog extends DialogComponent {

  state = {
    name: '',
    description: '',
    error: null
  };

  render() {
    return (
      <div className="d-flex flex-column">
        <input
          type="text"
          className="form-control"
          placeholder="نام الگو"
          onChange={this.handleNameChange}
        />
        <textarea
          className="form-control mt-3"
          onChange={this.handleDescriptionChange}
          placeholder="توضیحات الگو"
          rows={7}
        ></textarea>
        {this.renderError()}
        <button
          {...this.disableCheck()}
          onClick={this.handleSubmitClick}
          className="btn btn-primary mt-3 mr-auto">بارگذاری اطلاعات</button>
      </div>
    );
  }

  private renderError() {
    const { error } = this.state;
    if (error) {
      return (
        <div className="text-danger mt-3" style={{ fontSize: '0.95rem' }}>
          {error}
        </div>
      );
    }
    return '';
  }

  private disableCheck = () => {
    let { name, description } = this.state;
    name = name.trim();
    description = description.trim();
    if (name.length < 3) {
      return { disabled: true };
    }
    if (description.length < 3) {
      return { disabled: true };
    }
    return {};
  }

  private handleNameChange = (event: any) => this.setState({ name: event.target.value });

  private handleDescriptionChange = (event: any) => this.setState({ description: event.target.value });

  private handleSubmitClick = async () => {
    try {
      await templateService.create(this.state);
      this.close();
    }
    catch (e) {
      if (e && e.response && e.response.status === 409) {
        this.setState({ error: 'الگو قبلا با این نام ساخته شده است.' });
      }
    }
  }

}
